import axios from '../axios'

export const getServices = async (groupValue, lang, country, first, subUnitId, meetingLang) => {
  let url = `/services?group=${groupValue}&lang=${lang}&country=${country}&meeting_lang=${meetingLang}`
  if (!first) {
    url += `&sub_unit_id=${subUnitId}`
  }
  return await axios.get(url, {}).then(
    (response) => Promise.resolve(response),
    (error) => Promise.reject(error)
  )
}

export const getSubUnits = async (groupValue, lang, country, first, appointmentTypeId, meetingLang) => {
  let url = `/sub-units?group=${groupValue}&lang=${lang}&country=${country}&meeting_lang=${meetingLang}`
  if (!first) {
    url += `&appointment_type_group=${appointmentTypeId}`
  }
  return await axios.get(url, {}).then(
    (response) => Promise.resolve(response),
    (error) => Promise.reject(error)
  )
}
export const getAvailableDates = async (
  unitId,
  groupValue,
  appointmentId,
  lang,
  country,
  meetingLang,
  childrenCount
) => {
  return await axios
    .get(
      `/available-dates?sub_unit_id=${unitId}&group=${groupValue}&appointment_type_id=${appointmentId}&lang=${lang}&country=${country}&meeting_lang=${meetingLang}${childrenCount ? '&children_count=' + childrenCount : ''}`
    )
    .then(
      (response) => Promise.resolve(response),
      (error) => Promise.reject(error)
    )
}
export const getTimes = async (
  unitId,
  groupValue,
  appointmentId,
  date,
  lang,
  country,
  meetingLang,
  dateTo,
  childrenCount
) => {
  return await axios
    .get(
      `/times?sub_unit_id=${unitId}&group=${groupValue}&appointment_type_id=${appointmentId}&date=${date}&lang=${lang}&country=${country}&meeting_lang=${meetingLang}${
        typeof dateTo != 'undefined' ? '&date_to=' + dateTo : ''
      }${childrenCount ? '&children_count=' + childrenCount : ''}`
    )
    .then(
      (response) => Promise.resolve(response),
      (error) => Promise.reject(error)
    )
}

export const updateAppointment = async (appointmentDataObject) => {
  return await axios.post(`/submit-appointment`, appointmentDataObject).then(
    (response) => Promise.resolve(response),
    (error) => Promise.reject(error)
  )
}

export const reserveAppointment = async (appointmentDataObject) => {
  return await axios.post(`/reserve-appointment`, appointmentDataObject).then(
    (response) => Promise.resolve(response),
    (error) => Promise.reject(error)
  )
}
